import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CrudService } from "src/app/components/shared/cruds/crud.service";

@Injectable({ providedIn: "root" })
export class DashService {

  constructor(protected http: HttpClient) {}
  public get(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/dashboard/get`);
  }
}
